import { render } from "./AspectImage.vue?vue&type=template&id=70eb9077&scoped=true"
import script from "./AspectImage.vue?vue&type=script&lang=js"
export * from "./AspectImage.vue?vue&type=script&lang=js"

import "./AspectImage.vue?vue&type=style&index=0&id=70eb9077&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70eb9077"]])

export default __exports__